import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';

const RenderSadfinderLight = () => {
const awcurl=sessionStorage.getItem("AWC_URL");
const awsurl=sessionStorage.getItem("AWS_URL");
const resturl=sessionStorage.getItem("REST_URL");

let emptySadfinder={};
var emptyselectedsad;
var emptyExitnote=null;

//var boolFetchingSads=false;
/*
SELECT TPT_LOC, IDE_AST_DAT, IDE_CUO_COD, IDE_REG_NBR, RLO_NBR, PTY_NBR_ITM, ext_NBR_ITM, PTY_COL_DSC, IDE_RCP_NBR
FROM SAD_GENERAL_SEGMENT
WHERE INSTANCEID=444654
TS003	30-JAN-25	PSD	2723	1	1	0	Green	609
pAP 2025 E 1584 AL SERVICES LTD SOUTH DO
*/

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [crit, setCrit] = useState({
date1:''
, color:''
, status:''
, regnbr:''
, decorcmp_name:''
, yearname:''
, IDE_CUO_COD:''
, TPT_LOC:''
, STR_SHD_NAM:''
, YRMM:''
});


const [yearoptions, setYearoptions] = useState([]);
const [coloroptions, setColoroptions] = useState([]);
const [city, setCity] = useState({name:''});
const [itemselecterror, setItemselecterror] = useState({msg:'you must select one or more items before continue'});
const [selecteditems, setSelecteditems] = useState({checkcount:''});
const [statusoptions, setStatusoptions] = useState([]);


//const [ctryCod, setCtryCod] = useState([]);
//const [ctryNam, setCtryNam] = useState([]);
const [ctycods, setCtycods] = useState([]);
const [ctyopts, setCtyopts] = useState([]);

const [hiddenCtyInputs, setHiddenCtyInputs] = useState([]);
const [tblsadcnttrashdyear, settblsadcnttrashdyear] = useState([]);
const [dowait, setDowait] = useState({show:false});

const [tblsadfinder, setTblsadfinder] = useState([]);
const [exitnoteitemrows, setExitnoteitemrows] = useState([]);


const [statusOptions, setStatusOptions] = useState([]);
const [trashedOptions, settrashedOptions] = useState([]);

const [tbldetails, setTbldetails] = useState([]);

const [transkey, setTranskey] = useState({
seqno:0
,LOCK_INFO:''
});


const [sad, setSad] = useState({
	INSTANCEID:null
});


const [exitnote, setExitnote] = useState({
 EXT_PLC:''
, TPT_NAM:''
, TPT_INF:''
, TPT_IDE:''
, TPT_NAT_COD:'TC'
, TPT_NAT_NAM:''
});




const location = useLocation();


useEffect(() => {


	if (!sessionStorage.getItem("AW_USERNAME")){
	navigate("../logout");
	return;
	}


getyearoptions();
resetColoroptions();
//resetFinderCriteria();
resetStatusoptions();

//emptyselectedsad=selectedsad;
if (document.getElementsByName("critname")[0])
	document.getElementsByName("critname")[0].focus();

/*
initialize all autocomplete to avoid error 
Error: cannot call methods on autocomplete prior to initialization; attempted to call method 'enablesearch'
*/
    $( "#TPT_INF" ).autocomplete({source: []});   
    $( "#TPT_IDE" ).autocomplete({source: []});  
 },[]);


useEffect(() => {
	
	//console.log(JSON.stringify(sad));
	
	if (sad.INSTANCEID!=null){
		//setBoolFetchingSads({flag:false}); 
		resetexitnoteform();
		openCity(null, 'sadchecklisttc');
		
		fetchItemsToExit();
		getseqno(null, sad.INSTANCEID);
		}
 },[sad.INSTANCEID]);

useEffect(() => {
/*
original trigger is crit.TPT_LOC
was changed to JSON.stringify(tblsadfinder)]
*/	
	if (crit.TPT_LOC!="")
		getexitnotehist(crit.TPT_LOC);
		
 },[crit.TPT_LOC]);


useEffect(() => {
	
	if (document.getElementById("exitnoteform"))
		document.getElementById("exitnoteform").style.visibility=(itemselecterror.msg=="Ok")?"visible":"hidden";
		
 },[itemselecterror.msg]);




useEffect(() => {
	
if (city.name=="sadchecklisttc" || city.name=="exitnoteformtc"){

  var tablinks = document.getElementsByClassName("tablinks");
  console.log("tablinks.length: "+tablinks.length);
  
  for (var i = 0; i < tablinks.length; i++) {
	tablinks[i].className = tablinks[i].className.replace(" active", "");
	
	console.log("tablinks[i].id: "+tablinks[i].id);
	if (tablinks[i].id+"tc"==city.name)
		tablinks[i].classList.add("active");

	}//end for
	
}//end if
		
 },[city.name]); 
 
useEffect(() => {
	
	if (ctycods.length>0)
		setExitnote((prev)=>{
			return {...prev, TPT_NAT_COD:"TC", TPT_NAT_NAM:"Turks and Caicos Islands"}
		});
		
 },[JSON.stringify(ctycods)]);

 
useEffect(() => {
	
	if (tblsadcnttrashdyear.length>0)
		openCity(null, "officemonths");
		
 },[JSON.stringify(tblsadcnttrashdyear)]);
 
 useEffect(() => {
	
	if (tblsadfinder.length>0)
		openCity(null, "sadfinderresults");
		
 },[JSON.stringify(tblsadfinder)]);
 
 
 
 
useEffect(() => {
	
	console.log("crit.yearname: "+crit.yearname);
	
	if (crit.yearname!="")
		gettblsadcnttrashdyear();
		
 },[crit.yearname]);

useEffect(() => {
	
	console.log("crit.TPT_LOC: "+crit.TPT_LOC);

	if (crit.TPT_LOC==""){
		openCity(null, "officemonths");
		}
	else{
		if (tblsadfinder.length==0)
			callsadfinder(null);
		}//ens id

 },[crit.TPT_LOC]);
 
 
 useEffect(() => {
	
	//callsadfinder(null);

 },[crit.decorcmp_name, crit.regnbr]);
 
 
useEffect(() => {


console.log("exitnote.TPT_NAM: "+exitnote.TPT_NAM);

if (exitnote.TPT_NAM==""){
/*
2025-04-08
removed these resets bc they are initialize by getexitnotehist() with filter of sad.TPT_LOC
so maybe can reset when sad.TPT_LOC change, not exitnote.TPT_NAM
    $( "#TPT_INF" ).autocomplete({source: []});   
    $( "#TPT_IDE" ).autocomplete({source: []}); 	

*/

	}//end if
//else
	//move this to onBlur event getexitnotedriver();


if (emptyExitnote==null && exitnote!=null){
	//emptyExitnote=exitnote;
	//console.log("initialize emptyExitnote to: "+JSON.stringify(emptyExitnote));
	//THIS stuff never worked
	}//end if

 },[exitnote.TPT_NAM]);
 







  const handleFocus = (e) => {
  //e.target.blur();
  if (e.target.readOnly)
	e.target.style.background='gainsboro';
/*
else 
	e.target.select();
*/
	e.target.select();

	}//end func


function submitform1(e){
e.preventDefault();	
//clickMonthOffice(e, IDE_CUO_COD, YRMM);
callsadfinder(e);
//openCity(null, "exitnoteform");

}//end func


function resetexitnoteform(){

if (emptyExitnote!=null){
	console.log("will assign emptyExitnote: "+emptyExitnote);
	setExitnote(emptyExitnote);
	}//end if
	

var i=0, len=document.getElementsByName('cbexitnoteitems').length;
for (i=0; i<len; i++)
	document.getElementsByName('cbexitnoteitems')[i].checked=false;

document.getElementById('cbcheckall').checked=false;

checkItemselecterror();	
}//end func


async function callsadfinder(e){
	if (e)
		e.preventDefault();	
/*
if (crit.date1=="")	{
	showsnackbar("please click a date first");
	return;
	}

*/
	
let params={
	USERNAME: sessionStorage.getItem("AW_USERNAME")
	, IDE_CUO_COD: ''	
	, TPT_LOC: crit.TPT_LOC
	, yearname: crit.yearname
	, date1: ''	
	, color: ''	
	, status: ''	
	, regnbr: crit.regnbr
	, decorcmp_name: crit.decorcmp_name
};

//console.log("callsadfinder: "+JSON.stringify(params));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

setDowait({show:true});
	setTblsadfinder([]);
//document.getElementById("btnsearch").style.visibility="hidden";

await  fetch(resturl+'rarsad/sadfinder',requestOptions)
      .then(res => res.json())
      .then(res => aftercallsadfinder(res))
      .catch(err => console.log(err));
	  

}//end func  

function aftercallsadfinder(res){
	
	//document.getElementById("btnsearch").style.visibility="visible";
	
	setDowait({show:false});
if (!res.length){
/*
	document.getElementById('btndosearch').style.display='block';
	document.getElementById('imgwaitsearch').style.display='none';
*/
	return;
	}
	
let htmrows=[];
var rownum=1;
//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
/*
<input  type="radio" name="cbsad"  id={sadlinkid} onClick={(e)=>{openSad(e, col['INSTANCEID']);}}  /><label className="hand" htmlFor={sadlinkid} >&nbsp;{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</label>
<a href="#" target="_blank" className="nodecor" onClick={(e)=>{openSad(e, col['INSTANCEID']);}} >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</a>
window.open(this.makeHref("sad"))
<a href="#" target="_blank" onClick={(e) => {openSad(e, instanceId); }} >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</a>
<Link to={{pathname: "/sad", state:{instanceid:instanceId, sad_payment_groupid:0}  }} target="_blank" >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</Link>
*/
res.map((col, index) => {
	const key='sadfinder'+index;
	const sadlinkid='sadlinkid'+index;
	const instanceId=col['INSTANCEID'];
	const TPT_LOC=col['TPT_LOC'];
	const STR_SHD_NAM=col['STR_SHD_NAM'];
	
	
	if (rownum==1 && STR_SHD_NAM!=sad.STR_SHD_NAM){
		console.log("STR_SHD_NAM: "+col['STR_SHD_NAM']);
		setSad((prev)=>{
			return {...prev, STR_SHD_NAM:STR_SHD_NAM}
		});
		}//end if
	
	htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="left" >{col['IDE_CUO_COD']}</td>
		<td align="left" >
		<a href="#" target="_blank" className="nodecor" onClick={(e) => {fetchSad(e, instanceId, TPT_LOC, STR_SHD_NAM); }} >{col['REG_NBR']}</a>
		</td>
		<td align="left" >{col['DEC_COD']}</td>
		<td align="right" >{col['NOT_EXT_NBR_ITM']}</td>
		<td align="right" >{col['PTY_COL_DSC']}</td>
		<td align="right" >{col['STR_FIN_AMT_TBP']}</td>
		<td align="center" >{col['STR_RCP_DAT']}</td>
		<td align="left" >{col['STR_CON_NAM']}</td>
		</tr>
	);
	rownum++;
	}//end for
	);

if (rownum>0){
	setDowait({show:false});
	setTblsadfinder(htmrows);	
	}
else
	setDowait({show:false});

/*
document.getElementById('btndosearch').style.display='block';
document.getElementById('imgwaitsearch').style.display='none';

*/
	
}//end func


async function getyearoptions(){
	

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

 await fetch(resturl+'rarsad/getyearoptions',requestOptions)
      .then(res => res.json())
      .then(res => aftergetyearoptions(res))
      .catch(err => console.log(err));

}//end func

function aftergetyearoptions(res){

if (!res.length)
	return;

let temp=[];
let firstyearname=crit.yearname;
res.map((col, index) => {
	const key="yearoptions_"+index;
	const yearname=col['YEARNAME'];
	//let selected="";
	//console.log("LATEST_SAD_DATE "+col['LATEST_SAD_DATE']);
	if (col['LATEST_SAD_DATE']!=null && firstyearname==""){
		firstyearname=yearname;
		//selected=" selected ";
		}//end func
		
	
	temp.push(<option key={key+"_cod"} value={yearname} >{yearname}</option>);
	});//end map

setYearoptions(temp);
setCrit((prev)=>{
	return {...prev, yearname:firstyearname}
	});
}//end func

function resetColoroptions(){
let htmrows=[];

const colors='All Colors,Red,Yellow,Blue,Green'.split(',');
for (var i=0; i<colors.length; i++){
	const color=colors[i];
	const key='coloroption'+color;
	
	const value=(color.startsWith("All"))?"":color;
	
	htmrows.push(<>
	<option key={key} value={value} >{color}</option>
	</>);
	}

setColoroptions(htmrows);

/*
let currentYear = new Date().getFullYear();
for (var i=0; i<15; i++){
	const yr=currentYear-i;
	const key='yroption'+yr;
	htmrows.push(<>
	<option key={key} value={yr} >{yr}</option>
	</>);
	if (i==0)
		setCrit((prev)=>{
			return {...prev, year:yr}
			});

	
	}//end for
setYearoptions(htmrows);
*/

}//end func

function resetStatusoptions(){
const arrOptions="Assessed,Exited,Stored,Paid,Registered,Cancelled".split(",");
let arrJsx=[];

arrOptions.map((opt, index) => {
	const key="statusopt_"+index;
	arrJsx.push(<option value={opt} key={key} >{opt}</option>);
	});

setStatusoptions(arrJsx);
}//end func




async function sendtoaws(args, seqno){

const url= awsurl + "instanceid="+sad.INSTANCEID+"&seqno="+seqno+"&"+args;

console.log('url: '+url);
await fetch(url,{method: 'GET'})
.then(res => res.json() )
.then(res => aftersendtoaws(res, args, seqno) )
.catch(err => console.log(err));       
	  
}//end func


function aftersendtoaws(res, args, seqno){
console.log('aftersendtoaws args: '+args);
//console.log('aftersendtoaws res: '+JSON.stringify(res));

document.getElementById('btnexitnote').style.visibility='visible';

if (res.success=='true'){
	if (args=='op=new-exitnote'){
		console.log('next up sendtoaws op=exitgoods');
		const EXT_INSTANCE_ID=res.EXT_INSTANCE_ID;
		console.log('EXT_INSTANCE_ID:'+EXT_INSTANCE_ID);
		setSad((prev)=>{
			return {...prev, EXT_INSTANCE_ID:EXT_INSTANCE_ID}
		});
		sendtoaws("op=exitgoods", seqno);
		}//end if

	if (args=='op=exitgoods'){
		alert('the new exit note was created and goods exited!');
		resetexitnoteform();
		openCity(null, 'officemonths');
		}//end if
		
	}//end if
else{
	alert(res.ERR?res.ERR:'operation failed! please try again');
	return;
	}//end else
		
}//end func


function openSad(instanceid){
//e.preventDefault();


const state={
			sad_payment_groupid:0
			,instanceid:instanceid
			,from_sad_finder:1
			};


navigate(`/sad`,{state:state});




	}//end func






 







async function fetchSad(e, instance_id, TPT_LOC, STR_SHD_NAM){
	
if (TPT_LOC!=crit.TPT_LOC)
	setCrit((prev)=>{
		return {...prev, TPT_LOC:TPT_LOC, STR_SHD_NAM:STR_SHD_NAM}
		})	;

if (STR_SHD_NAM!=sad.STR_SHD_NAM)
	setSad((prev)=>{
		return {...prev, STR_SHD_NAM:STR_SHD_NAM}
	});
	
	if (e)
		e.preventDefault();
console.log('fetchSad instance_id: '+instance_id);



const params={
INSTANCEID: instance_id
,KEY_ITM_NBR: 1
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//setBoolFetchingSads({flag:true});

 await fetch(resturl+'rarsad/getsad',requestOptions)
      .then(res => res.json())
      .then(res => aftergetsad(res))
      .catch(err => console.log(err));

	  

	  
}//end func 

function aftergetsad(res){
	
//	setBoolFetchingSads({flag:false});
	
	var datas={};
for(var attributename in res[0]){
	const data=res[0][attributename];
	datas[attributename] = (data==null)?'':data;
	}//end for

//console.log("aftergetsad: "+JSON.stringify(datas));
setSad(datas);	
	
}//end func 


function fetchdetails(instanceId){

const params={
INSTANCEID:instanceId
, SEQNO:0
};

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};

console.log('will call getdetails: '+JSON.stringify(params));

fetch(resturl+'rarsad/getdetails',requestOptions)
  .then(res => res.json())
  .then(res => afterfetchdetails(res))
  .catch(err => console.log(err));		
	
}//end func


function afterfetchdetails(res){
let htmrows=[];
//console.log('afterfetchdetails item: '+JSON.stringify(lsitem[2]));
res.map((col, index) => {
		const key="afterfetchdetails_tr"+index;
		htmrows.push(<>
		<tr key={key} >
		<td>{col['DOC_VER']}</td>
		<td title={col['OP_NAME']} >{col['OP_NAME'].substring(0,14)}</td>
		<td>{col['FULLNAME'].substring(0,8)}</td>
		<td>{col['OP_DATE_TIME']}</td>
		</tr>
		</>
		);
		
	});//end map


//console.log('afterfetchdetails htmrows: '+JSON.stringify(htmrows));
setTbldetails(htmrows);

}//end function





function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


async function getexitnotedriver(){
//this is actully getexitnotedriverINFO - gets the given driver's info
if (""+sad.TPT_LOC.trim()=="" || ""+exitnote.TPT_NAM.trim()=="")
	return;

const params={
	SHD_COD : sad.TPT_LOC
	,TPT_NAM: exitnote.TPT_NAM
	}
console.log('getexitnotedriver: '+JSON.stringify(params));
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };


await  fetch(resturl+'rarsad/getexitnotedriver',requestOptions)
      .then(res => res.json())
      .then(res => aftergetexitnotedriver(res))
      .catch(err => console.log(err));	
	
}//end func



function aftergetexitnotedriver(res){
	
if (res.length==undefined)
	return;

let arrTPT_INF=[], arrTPT_IDE=[];
	
res.map((col, index) => {
		
		if (col['BAND']=='TPT_INF')
			arrTPT_INF.push(col['DRIVER_LIC_NBR']);
		else if (col['BAND']=='TPT_IDE')
			arrTPT_IDE.push(col['DRIVER_LIC_NBR']);
		
		});
	
	console.log('arrCmp.length: '+arrTPT_INF.length);
	
    $( "#TPT_INF" ).autocomplete({source: arrTPT_INF});   
    $( "#TPT_IDE" ).autocomplete({source: arrTPT_IDE});   
  
  $('#TPT_INF').autocomplete('search', '');
  document.getElementsByName('TPT_INF')[0].focus();	
	
}//end func



function openCity(evt, cityName) {
	if (evt!=null)
		evt.preventDefault();

//	currCity=cityName;

console.log('openCity cityName: '+cityName);

  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  //console.log('tabcontent.length: '+tabcontent.length);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
	}//end for

/*tablinks is set with the useEffect of city.name*/
	if (document.getElementById(cityName))
		document.getElementById(cityName).style.display = "block";
	setCity({name:cityName});
  
  if (cityName=="exitnoteformtc" && document.getElementsByName("TPT_NAM")[0])
	  document.getElementsByName("TPT_NAM")[0].focus();
 
 if (cityName=="sadfinderresults")
	 setSad({INSTANCEID:null});
 else if (cityName=="officemonths"){
	 //reset all
	 setCrit((prev)=>{
		 return {...prev, TPT_LOC:'', YRMM:'', STR_SHD_NAM:''}
	 });
	 setTblsadfinder([]);
	}//end if
 
 if (cityName=="exitnoteformtc"){
	 document.getElementById('btnexitnote').style.visibility='visible';
	 console.log("emptyExitnote: "+JSON.stringify(emptyExitnote));
	 
		setExitnote((prev)=>{
			return {...prev
			, EXT_PLC:''
			, TPT_NAM:''
			, TPT_INF:''
			, TPT_IDE:''
			, TPT_NAT_COD:"TC"
			, TPT_NAT_NAM:"Turks and Caicos Islands"}
		});
	 
	 	
	}//end if
 
  //evt.currentTarget.className += " active";
}//end function




	
async function fetchTrasheds(){
console.log('fetchTrasheds ');


    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };


 await fetch(resturl+'rarsad/gettrasheds',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchTrasheds(res))
      .catch(err => console.log(err));

	  
}//end func 	




	
function afterFetchTrasheds(res){
	
let htmrows=[];	
	
res.map((col, index) => {
	const strLocation=col['SHD_NAM'];
	const strCod=col['SHD_COD'];
	const key='Trasheds_'+index;
	htmrows.push(<option key={key} value={strCod} >{strLocation}</option>);
	});//end map

settrashedOptions(htmrows);

}//end func	


async function gettblsadcnttrashdyear(){
	

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {yearname: crit.yearname} )
  };

settblsadcnttrashdyear([]);
setDowait({show:true});

 await fetch(resturl+'rarsad/tblsadcnttrashdyear',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblsadcnttrashdyear(res))
      .catch(err => console.log(err));

}//end func

/*
the month loop was previously for fiscal year
		for (var i=4; i<=15; i++){
			const mm=(i>12)?i%12:i;
			
			const colNam=(mm<10)?"AMT0"+mm:"AMT"+mm;
			ARRAY_YRMM.push(col[colNam]);
			}//end for
*/

function aftergettblsadcnttrashdyear(res){

setDowait({show:false});

if (!res.length)
	return;

let temp=[];
let ARRAY_YRMM=[];
let rownum=1;
res.map((col, index) => {
	const key="tblcuomonth_"+index;
	
	
	const BAND=col['BAND'];
	
	if (BAND=="01"){
		for (var i=1; i<=12; i++){
			
			const colNam=(i<10)?"AMT0"+i:"AMT"+i;
			ARRAY_YRMM.push(col[colNam]);
			}//end for
		
		}
	else if (BAND=="02"){

		//if (temp.length==0)
		//	console.log("ARRAY_YRMM: "+JSON.stringify(ARRAY_YRMM));

	const SHD_NAM=col['SHD_NAM'];
	
	temp.push(	<tr key={key} >
				<td align="right" >{rownum}</td>
				<td align="left" title={SHD_NAM} >{col['TPT_LOC']}</td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[0], SHD_NAM);}} >{col['AMT01']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[1], SHD_NAM);}} >{col['AMT02']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[2], SHD_NAM);}} >{col['AMT03']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[3], SHD_NAM);}} >{col['AMT04']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[4], SHD_NAM);}} >{col['AMT05']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[5], SHD_NAM);}} >{col['AMT06']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[6], SHD_NAM);}} >{col['AMT07']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[7], SHD_NAM);}} >{col['AMT08']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[8], SHD_NAM);}} >{col['AMT09']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[9], SHD_NAM);}} >{col['AMT10']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[10], SHD_NAM);}} >{col['AMT11']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[11], SHD_NAM);}} >{col['AMT12']}</a></td>
				<td align="right" >{col['TOTAL']}</td>
				</tr>
				);
				rownum+=1;
		}//end else
			
		
			else if (BAND=="03"){

	

	temp.push(	<tr key={key} >
				<td align="right" ></td>
				<td align="left" >Total All Sheds</td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[0]);}} >{col['AMT01']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[1]);}} >{col['AMT02']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[2]);}} >{col['AMT03']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[3]);}} >{col['AMT04']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[4]);}} >{col['AMT05']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[5]);}} >{col['AMT06']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[6]);}} >{col['AMT07']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[7]);}} >{col['AMT08']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[8]);}} >{col['AMT09']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[9]);}} >{col['AMT10']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[10]);}} >{col['AMT11']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['TPT_LOC'], ARRAY_YRMM[11]);}} >{col['AMT12']}</a></td>
				<td align="right" >{col['TOTAL']}</td>
				</tr>
				);
				
		}//end else
		
	});//end map

settblsadcnttrashdyear(temp);
/*
reset these criteria in the case the table was previously loaded
*/
	 setCrit((prev)=>{
		 return {...prev, TPT_LOC:'', YRMM:'', STR_SHD_NAM:''}
	 });

}//end func


async function fetchItemsToExit(){
	
console.log('fetchItemsToExit ');

const args={
	INSTANCEID:sad.INSTANCEID
	, KEY_ITM_NBR:0
	};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify(args)
  };


 await fetch(resturl+'rarsad/tblsaditemstoexit',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchItemsToExit(res))
      .catch(err => console.log(err));

	  
}//end func 

function afterFetchItemsToExit(res){
	
let htmrows=[];	
	
res.map((col, index) => {
	const key='exititem_'+index;
	//const supQty=(col['TAR_SUP_QTY']==null)?'':col['TAR_SUP_QTY'];
	const KEY_ITM_NBR=col['KEY_ITM_NBR'];
	
	
	htmrows.push(
		<tr key={key} >
			<td  align="left" >{KEY_ITM_NBR}</td>
			<td  align="center" ><input type='checkbox' name='cbexitnoteitems' value={KEY_ITM_NBR} onClick={(e)=>{checkItemselecterror();}} id={key} /><label htmlFor={key} >{col['TAR_HSC_NB1']}</label></td>
			<td  align="right" >{col['VIT_WGT_GRS']}</td>
			<td  align="right" >{col['PCK_NBR']+' '+col['PCK_TYP_COD']}</td>
			<td  align="left" >{col['PCK_MRK1']}</td>
			<td  align="left" >{col['IDT']}<input name='CONTR_ID[]' value={col['IDT']} type='hidden' /></td>
		</tr>
	
	);
	});//end map

setExitnoteitemrows(htmrows);

}//end func	





async function getseqno(e, instanceid){
if (e)
	e.preventDefault();
//openCity(null, 'wait');
console.log('getseqno instanceid: '+instanceid);

/*const VIEW_OR_RETRIEVE=(location.state.sad_payment_groupid==0)?'V':'R';*/

const VIEW_OR_RETRIEVE='V';

const params={
username: sessionStorage.getItem("AW_USERNAME")
, SAD_PAYMENT_GROUPID: 0
, INSTANCEID: instanceid
, VIEW_OR_RETRIEVE: VIEW_OR_RETRIEVE
}//end function

//console.log(JSON.stringify( params ));
var seqno=null;

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

console.log('next: call rarsad/getseqno');
//toggleshowtoolbar(0);

await fetch(resturl+'rarsad/getseqno',requestOptions)
      .then(res => res.json())
      .then(res => {aftergetseqno(res, instanceid);} )
      .catch(err => console.log(err));
	  
return false;
}//end function


function aftergetseqno(res, instanceid,){
console.log('aftergetseqno res: '+JSON.stringify(res[0]));
//toggleshowtoolbar(1);
setTranskey( {...transkey
, seqno:res[0].SEQNO
, LOCK_INFO:res[0].LOCK_INFO
} );

if (sad.INSTANCEID==null)
	setSad((prev)=>{
		return {...prev, INSTANCEID:instanceid}
	});
	
//sendtoawc(args, instanceid, res[0].SEQNO);


}//end function

function jsCheckall(e, eleNam){
//console.log('e.target.checked: '+e.target.checked);

var i=0, len=document.getElementsByName(eleNam).length;

for (i=0; i<len; i++){
	document.getElementsByName(eleNam)[i].checked=e.target.checked;
	}//end for
checkItemselecterror();	
}//end func

function checkItemselecterror(){
var i=0, len=document.getElementsByName('cbexitnoteitems').length;
var checkCount=0, cntrError='', cntrId=null, errMsg="Ok";
let arrKeyitmmbr=[];

for (i=0; i<len; i++){
	
	if (document.getElementsByName('cbexitnoteitems')[i].checked){
		checkCount++;

		arrKeyitmmbr.push(document.getElementsByName('cbexitnoteitems')[i].value);
		
		const currCntrId = document.getElementsByName('CONTR_ID[]')[i].value;
		
		if (cntrId==null)
			cntrId=currCntrId;
		else{
			if (currCntrId!=cntrId)
				errMsg='you must select items with same Container-Id #';
			}//end else
		}//end if
	}//end for

//console.log('checkCounter: '+checkCount);

if (checkCount==0)
	errMsg="you must select one or more items before continue";
	
setSelecteditems({
	checkcount:checkCount==0?'':checkCount
	, arrKeyitmmbr:arrKeyitmmbr
	});
	
setItemselecterror({msg:errMsg});



}//end func

function clickMonthOffice(e, TPT_LOC, YRMM, SHD_NAM){
	console.log("clickMonthOffice TPT_LOC: "+TPT_LOC+" > "+SHD_NAM);
	
	if (e)
		e.preventDefault();

/*
normally reset regnbr to empty as when user click a month and office.
But for the quick search of regnbr (without office), obviously the regnbr must remain
*/
const regnbr=(TPT_LOC=="")?crit.regnbr:"";


	setSad((prev)=>{
		return {
			...prev
			, STR_SHD_NAM:SHD_NAM
			}
	});

	setCrit((prev)=>{
		return {
			...prev
			, regnbr:regnbr
			, TPT_LOC: TPT_LOC
			, YRMM: YRMM
			, STR_SHD_NAM:SHD_NAM
			}
	});
	
}//end func



async function getexitnotehist(TPT_LOC){

const params={
 SHD_COD: TPT_LOC
}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//sendtoawc(args, instanceid, SEQNO)

  await fetch(resturl+'rarsad/getcountries',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcountries(res) )
      .catch(err => console.log(err));	


  await fetch(resturl+'rarsad/getexitnotehist',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetexitnotehist(res) )
      .catch(err => console.log(err));	
	
}//end func

function aftergetexitnotehist(res){
	
	console.log("aftergetexitnotehist");
	
if (res.length==undefined)
	return;

let arrTPT_NAM=[], arrEXT_PLC=[];
	
res.map((col, index) => {
		
		if (col['BAND']=='TPT_NAM')
			arrTPT_NAM.push(col['DRIVER_NAME']);
		else if (col['BAND']=='EXT_PLC')
			arrEXT_PLC.push(col['DRIVER_NAME']);
		
		});

	console.log('arrCmp.length: '+arrTPT_NAM.length);
	
    $( "#TPT_NAM" ).autocomplete({source: arrTPT_NAM});   
    $( "#EXT_PLC" ).autocomplete({source: arrEXT_PLC});   
	
	
		
	
}//end func

function aftergetcountries(res){

if (!res.length)
	return;

let tempcty=[], tempopts=[];
	
res.map((col, index) => {
		const key="ctyopt_"+index;
		tempopts.push(<option key={key} value={col['CTY_DSC']} >{col['CTY_DSC']}</option>);
		tempcty.push({
			cod: col['CTY_COD']
			, nam: col['CTY_DSC']
			});
		
		});

setCtycods(tempcty);
setCtyopts(tempopts);

}//end func

async function sendExitNoteItemsToDb(e){

e.preventDefault();
document.getElementById('btnexitnote').style.visibility='hidden';

const params={
username: sessionStorage.getItem("AW_USERNAME")
, INSTANCEID: sad.INSTANCEID
, SEQNO: transkey.seqno
, arrKeyitmmbr:selecteditems.arrKeyitmmbr
}//end function

console.log("params: "+JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//sendtoawc(args, instanceid, SEQNO)

  await fetch(resturl+'rarsad/sendExitNoteItemsToDb',requestOptions)
      .then(res => res.json())
      .then(res => 	sendExitNoteToDb() )
      .catch(err => {console.log(err); document.getElementById('btnexitnote').style.visibility='visible';});
	  
}//end func

async function sendExitNoteToDb(){

	
//console.log("exitnote: "+JSON.stringify( exitnote ));

const params={
username: sessionStorage.getItem("AW_USERNAME")
, INSTANCEID: sad.INSTANCEID
, SEQNO: transkey.seqno
, OPER:'new-exitnote'
, EXT_PLC: exitnote.EXT_PLC?exitnote.EXT_PLC:''
, EXT_TPT_LOC: exitnote.TPT_LOC
, EXT_TPT_INF: exitnote.TPT_INF
, EXT_TPT_NAM: exitnote.TPT_NAM
, EXT_TPT_IDE: exitnote.TPT_IDE
, EXT_TPT_NAT_COD: exitnote.TPT_NAT_COD
, EXT_TPT_NAT_NAM: exitnote.TPT_NAT_NAM
, EXT_INSTANCE_ID: sad.EXT_INSTANCE_ID?sad.EXT_INSTANCE_ID:''
}//end function

console.log("params: "+JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//sendtoawc(args, instanceid, SEQNO)

  await fetch(resturl+'rarsad/sendExitNoteToDb',requestOptions)
      .then(res => res.json())
      .then(res => 	sendtoaws("op=new-exitnote", transkey.seqno) )
      .catch(err => console.log(err));
}//end func

/*
EXT_PLC
EXT_TPT_INF
EXT_TPT_NAM
EXT_TPT_IDE
EXT_TPT_NAT_COD
EXT_TPT_NAT_NAM
*/

function alterit(val){
	console.log('alterit '+val);
}
function makeLsStatus(){
const arrStatus='Stored,Registered,Assessed,Paid,Exited,Cancelled'.split(',');
let htmrows=[];
for (var i=0; i<arrStatus.length; i++){
	const strStatus=arrStatus[i];
	const key='brk_sta_'+i;
	htmrows.push(<option key={key} value={strStatus} >{strStatus}</option>);
	}//end for

setStatusOptions(htmrows);

}//end func  

function setYRMM(e, mm){
	
		setCrit((prev)=>{
		return {...prev, YRMM: crit.yearname+"-"+mm}
	});
	
}//end func

function calendyrChangeOld(e){
	setCrit((prev)=>{
		return {...prev, yearname:e.target.value}
	});
}//end func

function handleCritChange(e) {
//destructure an array of objects in JavaScript
e.preventDefault(); 
const {name, value}=e.target;
	

	setCrit((prev) => {
	return {...prev, [name]:value}
	},console.log('handleCritChange after  ') );
	
}//end func

function handleExitnoteChange(e) {
//destructure an array of objects in JavaScript
e.preventDefault(); 
const {name, value}=e.target;
console.log('handleExitnoteChange name: '+name+", "+value);	

	setExitnote((prev) => {
	return {...prev, [name]:value}
	});
	

if (name=="TPT_NAT_NAM"){
	//console.log('handleExitnoteChange: '+value);
	var ctyCod="";
	for (var i=0; i<ctycods.length; i++){
		if (ctycods[i].nam==value)
			ctyCod=ctycods[i].cod;
		}//end for
	console.log('ctyCod: '+ctyCod);
	setExitnote((prev) => {
	return {...prev, "TPT_NAT_COD":ctyCod}
	});
	}//end if

	
}//end func

function focusInput(e){
console.log("focusInput: "+e.target.name);
e.target.select();	

$('#'+e.target.name).autocomplete('enablesearch');

if (e.target.name=="TPT_INF")
	getexitnotedriver();


}//end func

	
function startexitnote(e, callerInfo){
	
}//end func

 return (
    <>

<div id="officemonths" align="center" className="tabcontent autolrmargin centercols1-1" style={{marginBottom:"12px" }} >
<div align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"22px"}} >Table of Monthly Inventory count per Transit Shed</div>
<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
<select name="yearname" onChange={(e)=>{handleCritChange(e);}} value={crit.yearname} >
{yearoptions}
</select>
&nbsp;
<input name="regnbr" value={crit.regnbr} onChange={(e)=>{handleCritChange(e);}} placeholder="regis. #" size="4" style={{textAlign:"center"}} onFocus={(e)=>{e.target.select();}} autoComplete="off" />
&nbsp;
<input name="decorcmp_name" value={crit.decorcmp_name} onChange={(e)=>{handleCritChange(e);}} placeholder="broker/importer code/name" size="22" onFocus={(e)=>{e.target.select();}} autoComplete="off" style={{textAlign:"center"}} />
<input type="image" src="img/transparent.png" border="0" />
</form>

 		{
		dowait.show==true && 
		<div align='center' style={{width:"90%"}}  ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
		}
		
{!dowait.show && <>
<table className="customers" id="tblsadcnttrashdyear" >
 <thead>
 <tr>
 <th>#</th>
 <th>Transit<br/>Shed</th>
 <th><input type="radio" name="rdmonth" value="1" id="rdmm01" onClick={(e)=>{setYRMM(e,'01');}} /><br/><label htmlFor="rdmm01" className="hand" >Jan</label></th>
 <th><input type="radio" name="rdmonth" value="2" id="rdmm02" onClick={(e)=>{setYRMM(e,'02');}} /><br/><label htmlFor="rdmm02" className="hand" >Feb</label></th>
 <th><input type="radio" name="rdmonth" value="3" id="rdmm03" onClick={(e)=>{setYRMM(e,'03');}} /><br/><label htmlFor="rdmm03" className="hand" >Mar</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm04" onClick={(e)=>{setYRMM(e,'04');}} /><br/><label htmlFor="rdmm04" className="hand" >Apr</label></th>
 
 <th><input type="radio" name="rdmonth" value="4" id="rdmm05" onClick={(e)=>{setYRMM(e,'05');}} /><br/><label htmlFor="rdmm05" className="hand" >May</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm06" onClick={(e)=>{setYRMM(e,'06');}} /><br/><label htmlFor="rdmm06" className="hand" >Jun</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm07" onClick={(e)=>{setYRMM(e,'07');}} /><br/><label htmlFor="rdmm07" className="hand" >Jul</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm08" onClick={(e)=>{setYRMM(e,'08');}} /><br/><label htmlFor="rdmm08" className="hand" >Aug</label></th>

 <th><input type="radio" name="rdmonth" value="4" id="rdmm09" onClick={(e)=>{setYRMM(e,'09');}} /><br/><label htmlFor="rdmm09" className="hand" >Sep</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm10" onClick={(e)=>{setYRMM(e,'10');}} /><br/><label htmlFor="rdmm10" className="hand" >Oct</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm11" onClick={(e)=>{setYRMM(e,'11');}} /><br/><label htmlFor="rdmm11" className="hand" >Nov</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm12" onClick={(e)=>{setYRMM(e,'12');}} /><br/><label htmlFor="rdmm12" className="hand" >Dec</label></th>
 
 <th>Total</th>
 </tr>
 </thead>
 <tbody>
  {tblsadcnttrashdyear}
 </tbody>
 </table>

 {/*
  <div align="center" style={{marginTop:"18px"}} >
 <a href="#" className="nodecor" id="btnstartexitnote" onClick={(e)=>{startexitnote(e, 'sadcount');}} ><img src="img/msexcel.gif" border="0" /> SAD count report for selected month</a>
 </div>
 */}

 </>
}
</div>


<div id="sadfinderresults" align="center" className="tabcontent centercols1-1 autolrmargin" >
<div  align="center" >
{crit.STR_SHD_NAM}
	<br/><a href="#" className="nodecor" onClick={(e)=>{openCity(e, "officemonths");}} ><img src="img/return.png" border="0" />&nbsp;return to Monthly Inventory</a>
	
</div>
	 <table align='center' className="customers"  >
	 <thead>
	 <tr>
	 <th>#</th>
	 <th>Office</th>
	 <th>Reg<br/>Nbr</th>
	 <th>Dec<br/>Cod</th>
	 <th>Items</th>
	 <th>Color</th>
	 <th>Assess<br/>Amt</th>
	 <th>Rcp<br/>Date</th>
	 <th>Consignee<br/>Name</th>
	 </tr>
	 </thead>


	 <tbody>
			{
			!dowait.show==true && tblsadfinder
			}
	 </tbody>
	 </table>
			{
			dowait.show==true && 
			<div align='center' style={{width:"90%"}}  ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
			}
</div>

<div align="center" className="centercols1-1 autolrmargin" >

{
	
(city.name=="sadchecklisttc" || city.name=="exitnoteformtc") && <>
	<div align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"18px"}} >
	<a href="#" className="nodecor" onClick={(e)=>{openCity(e, "sadfinderresults");}} ><img src="img/return.png" border="0" />&nbsp;{sad.REG_NBR_KEY+" "+sad.STR_DEC_NAM}</a>
	</div>	
	<div align='center' style={{color:"brown"}} >{itemselecterror.msg}</div>
	<div className="tab" style={{width:"100%"}} >
	  <button className="tablinks" id='sadchecklist' onClick={(e)=>{openCity(e, e.target.id+"tc");}} >{selecteditems.checkcount} Select Items</button>
	  <button className="tablinks" id='exitnoteform' onClick={(e)=>{openCity(e, e.target.id+"tc");}} style={{visibility:"hidden"}} >Exit Note Form</button>
	</div>
</>

}





	<div id="sadchecklisttc" className="tabcontent tabcontentbg" style={{width:"100%"}} >
			<table align="left"  border="1"  width='100%' className='tblexitnoteitems tabcontentbg'     >
			<thead>
			<tr>
				<th  align="left" >#</th>
				<th  align="center" ><input type='checkbox' id='cbcheckall' onClick={(e)=>{jsCheckall(e,'cbexitnoteitems');}} /><label htmlFor='cbcheckall' >Tariff</label></th>
				<th  align="left" >Lbs</th>
				<th  align="left" >Packg</th>
				<th  align="left" >Marks</th>
				<th  align="left" >Containr</th>
			</tr>
			</thead>
			<tbody>
			{exitnoteitemrows}
			</tbody>
			</table>
			
	</div>
	
	
	{/*
	8th-Apr-2025
	If a left margin appears in mobile view just ignore that.  It's probably right scroll-bar.
	Only appears if page originally laoded in desktop view
	absent if page originally laoded in mobile view
	
	*/}
	
	<div id="exitnoteformtc" className="tabcontent tabcontentbg" style={{width:"100%"}} >
	<form method="POST" id="form1" onSubmit={(e)=>{ sendExitNoteItemsToDb(e); }} >
			<table align='center' border='0' className="tblexitnoteform" >
			<tbody>
			<tr><td align='center'>
			      <div className="form-floating" align='center' >
				  <input type="text" name='TPT_LOC' id='TPT_LOC' className="form-control gnsbro" defaultValue={sad.STR_SHD_NAM} readOnly onFocus={(e)=>{e.target.select();}} autoComplete='off' placeholder="Location (Trans. Shed)"  />
                  <label htmlFor="TPT_LOC">Location (Trans. Shed)</label>
                  </div>
			</td></tr>
			
			<tr><td align='center'>
			{/*
			onBlur={(e)=>{getexitnotedriver(e);}}
			remove from TPT_NAM.onBlur and add to TPT_INF.onFocus
			*/}
			      <div className="form-floating" align='center' >
				  <input type="text" name='TPT_NAM' id='TPT_NAM' value={exitnote.TPT_NAM} onChange={(e)=>{handleExitnoteChange(e);}}  required  className="form-control" onFocus={(e)=>{focusInput(e);}} autoComplete='off' placeholder="Driver's name"  />
                  <label htmlFor="TPT_NAM">Driver&apos;s name</label>
                  </div>
			</td></tr>
			
			<tr><td align='center'>
			      <div className="form-floating" align='center' >
				  <input type="text" name='TPT_INF' id='TPT_INF' value={exitnote.TPT_INF} onChange={(e)=>{handleExitnoteChange(e);}} required className="form-control" onFocus={(e)=>{focusInput(e);}} autoComplete='off' placeholder="Driver's identification #"  />
                  <label htmlFor="TPT_INF">Driver&apos;s identification #</label>
                  </div>
			</td></tr>
			
			<tr><td align='center'>
			      <div className="form-floating" align='center' >
				  <input type="text" name='TPT_IDE' id='TPT_IDE' value={exitnote.TPT_IDE} onChange={(e)=>{handleExitnoteChange(e);}} required className="form-control" onFocus={(e)=>{focusInput(e);}} autoComplete='off' placeholder="Vehicle license plate #"  />
                  <label htmlFor="TPT_IDE">Vehicle license plate #</label>
                  </div>
			</td></tr>

			<tr><td align='center'>
					<table align='center'>
					<tbody>
					<tr>
					<td align='center'>Nationality: <input name='TPT_NAT_COD' id='TPT_NAT_COD' size="2" type="hidden" defaultValue={exitnote.TPT_NAT_COD} readOnly className="gnsbro" /></td>
					</tr>
					<tr>
					<td align='center'>
						<select name='TPT_NAT_NAM' id='TPT_NAT_NAM' required value={exitnote.TPT_NAT_NAM} onChange={(e)=>{ handleExitnoteChange(e); }}    >
						<option value='' >***Nationality***</option>
						{ctyopts}
						</select>
					</td>
					</tr>
					</tbody>
					</table>
				</td></tr>
			<tr><td align='center'>
			      <div className="form-floating" align='center' >
				  <input type="text" name='EXT_PLC' id='EXT_PLC' value={exitnote.EXT_PLC} onChange={(e)=>{handleExitnoteChange(e);}} required className="form-control" onFocus={(e)=>{focusInput(e);}} autoComplete='off' placeholder="Place of exit of goods"  />
                  <label htmlFor="EXT_PLC">Place of exit of goods</label>
                  </div>
			</td></tr>


			<tr><td align='center' style={{"paddingTop":"6px"}}>
				<a href='#' ><img src='img/return.png' onClick={(e)=>{openCity(e, 'sadchecklisttc');}} border='0' title='return' /></a>
				&nbsp;&nbsp;&nbsp;
				<button className='button' id='btnexitnote'  >create exit note</button>
				</td>
			</tr>

			<tr>
				<td align='center'>
				No. of Items:
				<input size="1" name="checkcount" value={selecteditems.checkcount} required readOnly className="gnsbro" style={{border:"none", textAlign:"center"}} />			
				</td>
			</tr>



			</tbody>
			</table>	
			</form>
	</div>	
	
</div>
<table align="center">
<tbody>
<tr>
<td align="center" ><input size="8" readOnly className="gnsbro" value={crit.TPT_LOC} /></td>
<td align="center" ><input size="8" readOnly className="gnsbro" value={crit.YRMM} /></td>
<td align="center" ><input size="8" readOnly className="gnsbro" value={crit.STR_SHD_NAM} /></td>
</tr>
</tbody>
</table>
			
<div id='snackbar' ></div>

    </>
  );
  


};


export default RenderSadfinderLight;